import { DateTime } from 'luxon';
import { isNumber } from 'lodash';

export const getFormattedDate = ({
  date,
  locale,
  shouldDisplayTime = true,
}: {
  date: string | number;
  locale: string;
  shouldDisplayTime?: boolean;
}): string => {
  // TODO: Remove this case once backend fully supports ISO8601 date format
  const dateTime = isNumber(date)
    ? DateTime.fromMillis(date)
    : DateTime.fromISO(date, { setZone: true });

  return dateTime
    .setLocale(locale)
    .toLocaleString(shouldDisplayTime ? DateTime.DATETIME_SHORT : undefined);
};
